<script setup lang="ts">
// Pagination du rayon « associations » : /associations/page/2, /page/3, …
// Page 1 n'existe PAS sous cette forme (elle vit sur /associations) — sinon deux URLs
// pour le même contenu. Une page hors bornes renvoie un vrai 404 plutôt qu'une
// page vide indexable.
const route = useRoute();
const pageParam = Number((route.params as Record<string, string>).n);

if (!Number.isInteger(pageParam) || pageParam < 2) {
  throw createError({ statusCode: 404, statusMessage: "Page introuvable" });
}

definePageMeta({ key: (route) => route.path });
</script>

<template>
  <ListingView type="associations" :page="pageParam" />
</template>
